export default "__VITE_ASSET__e8a401b3__"